"use client";
import { EyeIcon, PencilIcon } from "lucide-react";

export function SvgPreviewToggle({
  isPreviewMode,
  onToggle,
}: {
  isPreviewMode: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="rounded border border-border bg-background/80 px-2 py-0.5 text-[12px] font-semibold shadow-sm transition hover:bg-muted focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring cursor-pointer flex items-center gap-1.5"
    >
      {isPreviewMode ? (
        <>
          <PencilIcon className="w-3 h-3" />
          Edit SVG
        </>
      ) : (
        <>
          <EyeIcon className="w-3 h-3" />
          Preview
        </>
      )}
    </button>
  );
}
